<template>
  <div style="margin-bottom: 15px; display: flex; align-items: center; justify-content: center; gap: 15px;">
    <h3>
      {{ popoverTitle }}
    </h3>
    <span v-if="showChannel && store.showAdvanced" style="font-family: 'Reddit Mono'; padding-top: 1px;">
      {{ channelLabel }}
    </span>
  </div>
  <Keypad
    :value="value"
    :suffix="convertedUnitHtml(unit)"
    :formatter="formatValue"
    @ok="onSubmit"
    @cancel="onCancel"
  ></Keypad>
</template>

<script setup>
import { computed } from "vue";
import store from "./store.js";
import Keypad from "./Keypad.vue";
import { controlChannelLabel } from "./appUtility.js";
import { roundToNearestFixedRange } from "./utility.js";
import { convertUnit, convertedUnitHtml, unconvertValue } from "./units.js";

let props = defineProps([
  "sensor",
  "popoverTitle",
  "showChannel",
  "value"
]);

let emit = defineEmits(["ok", "cancel"]);

let channelLabel = controlChannelLabel(props.sensor);

let unit = computed(() => {
  let system = props.sensor.$session.system;
  let parents = props.sensor.$parents();
  let aggregate = parents.find(parent => parent.sensors);
  let sensorType = system.sensorTypes.value[aggregate.sensorType.value];
  return sensorType.unit;
});

let convertedUnit = computed(() => {
  return convertUnit(unit.value);
});

function formatValue(convertedValue) {
  return roundToNearestFixedRange(
    convertedValue,
    props.sensor.$convertedMinPrecision(),
    props.sensor.$convertedMaxPrecision(convertedUnit.value)
  );
}

function onSubmit(convertedValue) {
  let sensor = props.sensor;
  let session = sensor.$session;
  let system = session.system;
  let unconvertedValue = unconvertValue(convertedValue, convertedUnit.value);
  if (system.controller.ioMode.value == 0) {
    session.queueRequest("/cmd/sendCalibrationOffset", {
      portNumber: sensor.portNumber.value,
      channelNumber: sensor.channelNumber.value,
      oldValue: sensor.$value(),
      newValue: unconvertedValue
    });
  }
  else {
    session.queueRequest("/cmd/setAnalogInput", {
      portNumber: sensor.portNumber.value,
      channelNumber: sensor.channelNumber.value,
      value: unconvertedValue
    });
  }
  emit("ok");
}

function onCancel() {
  emit("cancel");
}

</script>